export const palette = {
  appleGreen: '#d9efe0',
  asparagus: '#81A16F',
  black: '#000000',
  blondeShell: '#FDDD80',
  border: '#f5f5f5',
  brand: '#A79A46',
  carouselPink: '#f7dce1',
  chinesePurple: '#6D099C',
  cranberrySplash: '#D95069',
  greenKelp: '#243D20',
  guardBlue: '#0063B3',
  juggleGreen: '#27AE60',
  lavenderMist: '#F3E5FF',
  primary: '#A79A46',
  royalBrown: '#5D352B',
  royalty: '#ded4ef',
  sapphire: '#E6F5FE',
  secondary: '#999999',
  sedonaSage: '#696E6B',
  squant: '#666666',
  violet: '#9000FF',
  white: '#FFFFFF',
  yellowOchre: ' #CD9A05'
}
